module.exports = __webpack_public_path__ + "img/stp_url_orange.b9545d28.svg";